import coreUtils from "./coreUtils";

const customUtils = {
  calendlyDemoUrl: `https://cal.com/siddhant-mohan/45mins?month=${coreUtils.getYear()}-${coreUtils.getMonth()}`
};

export default customUtils;
